import React, { useState, useEffect } from 'react';
import {
  Modal,
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Chip,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { UserProfile } from 'src/interfaces/user';
import { useToast } from 'src/hooks/useToast';

interface EditUsertabModalProps {
  open: boolean;
  rolesObject: Record<string, any>;
  handleClose: () => void;
  selectedUser: UserProfile;
  onUpdateRoles: (data: { 
    email: string;
    roles: string[];
    id: string;
    userType: string;
    org: string[];
  }) => Promise<void>;
}

const EditUsertabModal: React.FC<EditUsertabModalProps> = ({
  selectedUser,
  open,
  handleClose,
  rolesObject,
  onUpdateRoles,
}) => {
  console.log("Userprofile",selectedUser);
  console.log("rolesObject",rolesObject);
  const [email, setEmail] = useState<string>(selectedUser?.email ?? '');
  const [roles, setRoles] = useState<string[]>(selectedUser?.roles || []);
  const [id, setId] = useState<string>(selectedUser?.id ?? '');
  const [userType, setUserType] = useState<string>(selectedUser?.userType ?? '');
  const { showSuccess, showError } = useToast();

  useEffect(() => {
    setEmail(selectedUser?.email ?? '');
    setRoles(selectedUser?.roles || []);
    setId(selectedUser?.id ?? '');
    setUserType(selectedUser?.userType ?? '');
  }, [selectedUser]);

  const org = [
    ...(selectedUser?.brands ? ["brands"] : []),
    ...(selectedUser?.locations ? ["locations"] : []),
    ...(selectedUser?.servicerApp ? ["servicerApp"] : []),
  ];

  console.log("Org", org);

  const availableRoles = Object.keys(rolesObject).filter(
    // (key) => rolesObject[key].type === 'external'
    (key) => rolesObject[key].type == selectedUser.userType 
  );

  const handleRoleChange = (event: any) => {
    setRoles(event.target.value);
  };

  const handleRemoveRole = (roleToRemove: string) => {
    setRoles((prevRoles) => prevRoles.filter((role) => role !== roleToRemove));
  };

  const handleSave = () => {
    debugger;
    onUpdateRoles({email, roles, id, userType, org})
      .then(() => {
        showSuccess(`Roles updated successfully for ${email}`);
        handleClose();
      })
      .catch(() => {
        showError(`Failed to update roles for ${email}. Please try again.`);
      });
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        {/* Close Button */}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Typography fontWeight= "bold" variant="h5" component="h2" gutterBottom>
          Edit Roles
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          Info
        </Typography>

        <TextField
          label="Member"
          //variant="outlined"
          fullWidth
          margin="normal"
          value={selectedUser?.displayName || 'N/A'}
          disabled
        />

        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          disabled
        />

        <TextField
          label="Organization"
          variant="outlined"
          fullWidth
          margin="normal"
          value={selectedUser?.company || 'N/A'}
          disabled
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>User role(s)</InputLabel>
          <Select
            multiple
            value={roles}
            onChange={handleRoleChange}
            renderValue={(selected) => (
              <Box className="flex flex-wrap gap-1">
                {selected.map((role) => (
                  <Chip
                    key={role}
                    label={rolesObject[role].name}
                    className="bg-orange-500 text-white"
                    onDelete={() => handleRemoveRole(role)}
                  />
                ))}
              </Box>
            )}
            displayEmpty
          >
            {availableRoles.map((roleOption, index) => (
              <MenuItem key={index} value={roleOption}>
                {rolesObject[roleOption].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          fullWidth
          sx={{ mt: 2 }}
        >
          Save
        </Button>
      </Box>
    </Modal>
  );
};

export default EditUsertabModal;

